export default {"src":"/_next/static/media/breakfast.5fbbe4e4.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};